import React from 'react';
import '../Css/HomeBanner.css'
import resume from '../images/myResume.pdf'
import TypeAnimation from 'react-type-animation';
import Social from './Social';


const HomeBanner = () => {
    return (
        <div className='homeBanner-section mt-12 mb-32' id='homepage'>
            <div className='flex justify-center items-center'>
                <div className='lg:mr-60'>
                    <div>
                        <h2 className='text-yellow-500 text-xl lg:text-2xl '>Hello! I am  </h2>
                        <h1 className='text-white text-4xl lg:text-7xl font-bold '>Mohammad <br />  <span> Borhan Uddin </span></h1>
                        <h3 className='font-bold text-yellow-500 mt-7 lg:mt-12  lg:text-3xl'>Full Stack Developer</h3>
                        <ul className='lg:flex '>
                            <li className=''>Web Developer</li>
                            <li className='lg:ml-3 '> Programmer</li>
                            <li className='lg:ml-3 '> React Developer</li>
                        </ul>
                        <div className='mt-8 lg:mt-10 text-white'>
                            <a className='homepage-button bg-yellow-500 hover:bg-slate-800 text-yellow-500' href={resume} download='myResume'>Get Resume </a> 
                           <a className='homepage-button ml-5 lg:ml-7' href="#aboutme">About me</a>
                        </div>
                    </div>

                </div>
            </div>
            <div className='relative lg:absolute'>
                <Social></Social>
            </div>
        </div>
    );
};

export default HomeBanner;